import { render, staticRenderFns } from "./PrivateContentUserDemo.vue?vue&type=template&id=d00be1c0&"
import script from "./PrivateContentUserDemo.vue?vue&type=script&lang=js&"
export * from "./PrivateContentUserDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports